import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import JsonapiClient from '@holidayextras/jsonapi-client';
import axios from 'axios';
import { Menu } from 'semantic-ui-react';

import { authService } from '../../utils/auth-service';
import inviteCreatorToCampaign from '../../utils/invite-creator-to-campaign';
import hasRESTClient from '../../hocs/has-rest-client';
import InfluencerTable from '../../components/influencer-table2';
import TeamTable from '../../components/team-table';
import InvitedTable from '../../components/invited-table';

const pStyle = {
  textAlign: 'center',
};

const pageStyle = {
  marginTop: 50,
};

const MY_TEAM = 'My Team';
const MY_INFLUENCERS = 'My Influencers';

class Invitation extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    organisationId: PropTypes.string.isRequired,
    campaign: PropTypes.object,
    campaignId: PropTypes.string,
    campaignName: PropTypes.string,
  };

  static defaultProps = {
    campaign: null,
    campaignId: '',
    campaignName: '',
  };

  constructor() {
    super();

    this.state = {
      activeItem: MY_INFLUENCERS,
      influencers: [],
      team: [],
      campaign: null,
      originalTeam: [],
      processing: false,
    };

    this.client = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  componentDidMount() {
    const { campaign } = this.props;
    this.setState({
      campaign,
    });

    this.getInfluencers();
    this.getTeam();
  }

  getInfluencers = () => {
    const { organisationId } = this.props;
    const options = {
      filter: {
        organisation: organisationId,
      },
      include: ['influencer'],
      'page[limit]': 50,
      sort: ['createdDate'],
    };

    this.client.find('influencerLink', options)
      .then(links => {
        const influencers = _.map(links, link => link.toJSONTree().influencer);
        const sortedInfluencers = _.sortBy(influencers, ['name']);
        return this.setState({
          influencers: sortedInfluencers,
        });
      })
      .catch(console.log);
  }

  getTeam = searchTerm => {
    const { organisationId } = this.props;

    console.log('blah');

    const fetchOptions = {
      filter: {
        organisation: organisationId,
      },
      sort: ['name'],
      'page[limit]': 500,
    };

    if (searchTerm) {
      fetchOptions.filter.name = `~${searchTerm}`;
    }

    console.log(fetchOptions);

    this.client.get('organisations', organisationId)
      .then(org => {
        const orgJson = org.toJSON();
        return orgJson;
      })
      .then(orgJson => this.client.find('users', fetchOptions)
        .then(users => {
          const userJsons = _.map(users, u => u.toJSON());
          const { hostname } = window.location;

          const finalTeam = hostname.match(/voxogram/)
            ? _.reject(userJsons, u => u.email.match(/dyzio\.co/))
            : userJsons;
          console.log(`TEAM MEMBER COUNT: ${finalTeam.length}`);
          return this.setState({
            team: finalTeam,
            originalTeam: finalTeam,
            organisationName: orgJson.name,
          });
        }))
      .catch(console.log);
  }


  teamSearch = (e, { value }) => {
    const searchTerm = value;
    const searchRegex = new RegExp(searchTerm, 'i');
    const { originalTeam } = this.state;
    const filteredTeam = _.filter(originalTeam, tm => (tm.name.match(searchRegex) || tm.email.match(searchRegex)));
    this.setState({ team: filteredTeam });
  }

  handleInvitation = invitation => {
    const { campaign } = this.state;
    const { organisationId } = this.props;
    const campaignId = campaign ? campaign.id : this.props.campaignId;
    const campaignName = campaign ? campaign.name : this.props.campaignName;

    this.setState({
      processing: true,
    });

    return inviteCreatorToCampaign({
      client: this.client,
      campaignId,
      campaignName,
      organisationId,
      invitation,
    })
      .then(() => {
        this.refreshCampaign();
      })
      .catch(e => {
        console.log(e);
        this.refreshCampaign();
      });
  }

  handleTeamMemberInvitation = user => {
    const { campaign } = this.state;
    const { organisationId } = this.props;
    const campaignId = campaign ? campaign.id : this.props.campaignId;
    const permission = this.client.create('campaignPermission');

    permission.set('name', user.name);
    permission.set('campaign', {
      type: 'campaigns',
      id: campaignId,
    });
    permission.set('organisation', {
      type: 'organisations',
      id: organisationId,
    });

    permission.set('user', {
      type: 'users',
      id: user.id,
    });
    permission.set('role', user.role);

    permission.set('email', user.email);
    permission.set('bypassUserSwitch', true);
    permission.set('sendDailyNotifications', true);
    permission.set('sendWeeklyNotifications', true);

    return permission.sync()
      .then(ci => {
        const newPermission = ci.toJSON();
        console.log(newPermission);
        const ax = axios.create({
          baseURL: process.env.REACT_APP_API_BASE_URL,
          timeout: 2000,
          headers: {
            Authorization: `Bearer ${authService.getToken()}`,
          },
        });
        ax.post(`/campaigns/${campaignId}/relationships/members/`, {
          data: {
            type: 'campaignPermission',
            id: newPermission.id,
          },
        })
          .then(() => {
            this.refreshCampaign();
          });
      });
  }

  goToCampaign = () => {
    const { campaign } = this.state;
    const campaignId = campaign ? campaign.id : this.props.campaignId;

    if (campaign.campaignType === 'ACR') {
      this.context.router.push(`/acr-campaign/${campaignId}`);
    } else {
      this.context.router.push(`/campaign/${campaignId}`);
    }
  }

  refreshCampaign = () => {
    const { campaign } = this.state;
    const TIMEOUT = 1500;
    const campaignId = campaign ? campaign.id : this.props.campaignId;
    _.delay(
      () => this.client.get('campaigns', campaignId, { include: ['members', 'pendingInvitations'] })
        .then(newCampaign => {
          this.setState({
            campaign: newCampaign.toJSONTree(),
            processing: false,
          });
        }).catch(e => {
          console.Console.log('refresh campaign failed');
          console.log(e);
          this.setState({
            campaign,
            processing: false,
          });
        }), TIMEOUT, {});
  };

  handleInvitationDelete = invitation => {
    const { restClient } = this.props;
    return restClient.delete(`campaignInvitation/${invitation.id}`)
      .then(() => {
        window.location.reload(true);
      });
  }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  render() {
    const { activeItem, influencers, team, campaign, organisationName, processing } = this.state;
    const { organisationId, organisation } = this.props;

    return (
      <div style={pageStyle}>
        <h1 style={pStyle}>Add people to your campaign</h1>
        <p style={pStyle}>Invitation emails can be sent from the next screen</p>

        <Menu pointing widths="2" size="massive">
          <Menu.Item
            name={MY_INFLUENCERS}
            active={activeItem === MY_INFLUENCERS}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            name={MY_TEAM}
            active={activeItem === MY_TEAM}
            onClick={this.handleItemClick}
          />
        </Menu>

        <InfluencerTable
          influencers={influencers}
          organisationId={organisationId}
          organisation={organisation}
          campaign={campaign}
          visible={activeItem === MY_INFLUENCERS}
          onInvite={this.handleInvitation}
          processing={processing}
        />

        <TeamTable
          team={team}
          campaign={campaign}
          visible={activeItem === MY_TEAM}
          onInvite={this.handleInvitation}
          onAdd={this.handleTeamMemberInvitation}
          organisationName={organisationName}
          onSearchChange={this.teamSearch}
        />

        <InvitedTable campaign={campaign} deleteHandler={this.handleInvitationDelete} />

        <div style={pStyle}>
          <button
            className="large rose wide" onClick={this.goToCampaign}
          >
            <p>Take me to my campaign</p>
          </button>
        </div>

      </div>
    );
  }
}

Invitation.propTypes = {
  organisation: PropTypes.object.isRequired,
  restClient: PropTypes.object.isRequired,
};

export default hasRESTClient(Invitation);



/** WEBPACK FOOTER **
 ** ./src/containers/invitation/index.js
 **/